import { render } from "./DefaultTree.vue?vue&type=template&id=3bfa24c2"
import script from "./DefaultTree.vue?vue&type=script&lang=js"
export * from "./DefaultTree.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTree from 'quasar/src/components/tree/QTree.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTree,QCheckbox});
